/**
 * {
 *     "status": "SUCCESS",
 *     "data": {
 *         "orderId": "8398751ce65728320b",
 *         "paymentPageLink": "https://pay.withsurfboard.com/8398751ce65728320b?pi=BWZT39Cg30TFsgBi-0m0nDKDhS50s1brwnxFBWH77Ywjv6PlC6p0JcC5kc91sDrT2mxwx7Vjd1rPYuV2A8NNqbeWQ7_BlPG4_vG8ZI7Gx6PXU0yJgwZVSnA147yQ0002&add=IzBFNDRFMQ=="
 *     },
 *     "message": "Order created successfully"
 * }
 */
export interface SurfboardOrderCreationResponse {
  status: string, // 'SUCCESS'
  data: {
    orderId: string,
    paymentPageLink: string,
    shortLinkUrl: string
  },
  message: string
}
